import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { uid } from 'uid';
import { IoCloseSharp } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import axios from 'axios';
import { HiOutlineArrowNarrowLeft, HiOutlinePlusCircle } from 'react-icons/hi';
import { getRequiredErrorMessage } from '../../../../utils/common.utils';
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../../../interfaces/api';
import { USER } from '../../../../interfaces/auth.interface';
import TextInput from '../../../form-controls/TextInput';
import PersonalShopperContext from '../../../../context/PersonalShopperContex/PersonalShopperContex';
import { BeatLoader } from '../../../Spinners/Spinner';

interface Props extends PropsFromRedux {}

    interface Inputs {
        ItemLink: string;
        ItemName : string;
        Quantity : number;
        ItemDescription : string;
    }

  const schema = yup.object().shape({
    ItemName: yup
    .string()
    .required(getRequiredErrorMessage("Item Name")),
    ItemDescription: yup.string().required(getRequiredErrorMessage("Description")),
    Quantity: yup.number().required(getRequiredErrorMessage("Quantity")),
    ItemLink: yup
    .string()
    .required(getRequiredErrorMessage("Product Link")),
  });


  export const UpdateShopperItem: React.FC<Props> = ({
    resetApi,
    showModal,
    hideModal,
    modal,
    updateItem,
    updateItemState,
    getHistory
  }) => {

    const closeModal = () => {
        hideModal();
    };

    const modalProps = modal?.ownProps?.itemDetails;
    const [shopperDetails, setShopperDetails] = React.useState<any>();
    const [goToList, setGoToList] = React.useState(false);
    const [itemList, setItemList] = React.useState<any>([]);
    const history : any = useHistory();

    React.useEffect(() => () => {
        resetApi(API_KEYS.UPDATE_PERSONAL_SHOPPING_ITEM);
    },
    [resetApi]);

    React.useEffect(() => {
        setShopperDetails(modalProps);
    },[setShopperDetails])

    // console.log('shopper details',shopperDetails);

    const onSubmit = async (data: Inputs) => {
        const alldetails = shopperDetails;
        const list = [];
        const setobj = alldetails;
    
        itemList.push(alldetails);
        list.push(alldetails);

        // console.log('list here',list);

        setItemList(itemList.map((item : any) => {
            if(item.ShopperItemId == item.ShopperItemId ){
               
              return {...item,
                 
                Quantity : data.Quantity,
                ItemName : data.ItemName,
                ItemLink: data.ItemLink,
                ItemDescription : data.ItemDescription
              }
            };
            return item;
          })
          );

        setGoToList(true);
        // console.log('after updating', shopperDetails);
    }


    React.useEffect(() => {
        let itemDetails = shopperDetails;
        if(goToList){
            itemDetails = itemList;
            setShopperDetails(itemDetails);
            // console.log('item details in use effeect',itemDetails);
            updateItem(itemDetails[0].ShopperItemId,...itemDetails);
          
        }
    }, [goToList])


    React.useEffect(() => {
        if(!updateItemState?.loading && updateItemState?.success){
            getHistory();
            history.push('/shopping-history');
            hideModal();
        }
    },[!updateItemState?.loading, updateItemState?.success])

    const { handleSubmit, control, errors, reset, watch,register, setValue } = useForm<Inputs>({
        resolver: yupResolver(schema),
        defaultValues: modalProps
    });


    return(
        <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full sm:px-12 px-12 bg-white lg:px-36 py-10 relative">
           <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
          </button>
                <h2 className="font-bold mb-4 text-xl text-center my-6 mb-8">Item details</h2>
                {/* <div className="w-full mb-5 text-sm text-gray-500 font-medium">
                        <Controller
                            name="itemId"
                            control={control}
                            defaultValue=""
                            render={({ name, value, onChange }) => (
                            <TextInput
                                name={name}
                                value={value}
                                className="border-gray-300 border p-3 w-full rounded-md"
                                id={name}
                                type="hidden"
                                wrapperClassName="w-full"
                                error={errors['itemId']}
                                customChange={onChange}
                            />
                            )}
                        />
                    </div> */}
                <div className="w-full mb-5 text-sm text-gray-500 font-medium">
                        <Controller
                            name="ItemLink"
                            control={control}
                            defaultValue=""
                            render={({ name, value, onChange }) => (
                            <TextInput
                                name={name}
                                value={value}
                                className="border-gray-300 border p-3 w-full rounded-md"
                                id={name}
                                labelClassName="mb-2 flex "
                                label="Paste Product Link"
                                type="string"
                                wrapperClassName="w-full"
                                error={errors['ItemLink']}
                                placeholder="Paste Link"
                                customChange={onChange}
                            />
                            )}
                        />
                    </div>
                    <div className="mb-5 text-sm text-gray-500 font-medium">
                        <Controller
                            name="ItemName"
                            control={control}
                            defaultValue=""
                            render={({ name, value, onChange }) => (
                            <TextInput
                                name={name}
                                value={value}
                                className="border-gray-300 border p-3 w-full rounded-md"
                                id={name}
                                labelClassName="mb-2 flex "
                                label="Item Name"
                                type="string"
                                wrapperClassName="w-full"
                                error={errors['ItemName']}
                                placeholder="A brown nike shoe"
                                customChange={onChange}
                            />
                            )}
                        />
                    </div>
                  <div className="mb-5 text-sm text-gray-500 font-medium">
                  <Controller
                    name="Quantity"
                    control={control}
                    render={({ name, value, onChange }) => (
                    <TextInput
                        name={name}
                        value={value}
                        className="border-gray-300 border p-2 w-full rounded"
                        id={name}
                        labelClassName="mb-2 flex text-sm text-gray-500 font-medium "
                        label="Quantity"
                        type="number"
                        wrapperClassName="w-full"
                        error={errors['Quantity']}
                        placeholder="Quantity"
                        customChange={onChange}
                        
                    />
                    )}
                />
                </div>

                <div className="mb-5 text-sm text-gray-500 font-medium">
                     <Controller
                        name="ItemDescription"
                        control={control}
                        defaultValue=""
                        render={({ name, value, onChange }) => (
                        <TextInput
                            name={name}
                            value={value}
                            className="border-gray-300 border p-3 w-full rounded-xl"
                            id={name}
                            labelClassName="mb-2 ml-2 flex"
                            label="Description"
                            type="text"
                            multiline
                            rows={3}
                            wrapperClassName="w-full"
                            error={errors['ItemDescription']}
                            placeholder="eg. Color , texture, Fabric (Max 150 character)"
                            customChange={onChange}
                        />
                        )}
                    />
                </div>
         
                <button
                    className="w-full bg-secondary my-10 font-semibold text-sm rounded text-white py-4"
                    type="submit"
                    disabled={updateItemState?.loading}
                    >
                        {updateItemState?.loading ? <BeatLoader color="white" /> : 'Proceed'}    
                    </button>
              </div>
        </form>
    );

}